<template>
	<multiselect v-bind="$attrs" v-on="$listeners"
		:value="value" :options="sortedCities"
		track-by="id" label="name" :openDirection="openDirection"
		placeholder="Selecione uma cidade"
		selectLabel=" "
		deselectLabel=" "
		@search-change="debouncedListCities"
		:custom-label="getCityLabel"
		:internal-search="false">

		<span slot="noResult">Nenhum registro encontrado. Digite mais de 3 letras para buscar!</span>
		<span slot="noOptions">Digite mais de 3 letras para buscar!</span>

	</multiselect>
</template>

<script>
import { fetchModel } from '../../utils';
import DestinationService from '../../service/DestinationService';

export default {
	props: ['value', 'openDirection'],
	data(){
		return {
			cities: [],
			destinationService: new DestinationService()
		}
	},
	created(){
    this.debouncedListCities = _.debounce((name) => this.listCities(name), 500)
	},
	computed: {
    sortedCities() {
      return (this.cities || []).sort((a, b) => a.name.localeCompare(b.name));
    },
	},
	methods: {
    async listCities(name) {
      if(name.length >= 3) {
        this.cities = await fetchModel('cidades', () => this.destinationService.listCitiesByName(name));
      } else {
        this.cities = [];
      }
    },
    getCityLabel(city) {
      return city.name + (city.state ? ' (' + (city.state.uf ? city.state.uf : city.state.country.name) + ')' : '');
    },
	}
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/shared/CitySelect.vue